export const setDivision = (data) => {
  return {
    type: "DIVISION",
    data: data,
  };
};
